<div *ngIf="error" class="login-signup-error-banner error-banner">
    <mat-icon fontSet="phr-iconset" class="phr-iconset-alert"></mat-icon>
    <span>{{error}}</span>
</div>